// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const tckimlik: CountryValidator<"TR"> = createValidator(
  "tr.tckimlik",
  164,
);

export default tckimlik;
export const compact = tckimlik.compact;
export const format = tckimlik.format;
export const validate = tckimlik.validate;
export const generate = (): string =>
  tckimlik.generate?.() ??
  (() => {
    throw new Error(
      "Validator tr.tckimlik cannot generate values",
    );
  })();
